import type { FleetSummary as FleetSummaryData } from '../../lib/aggregates.ts';

interface FleetSummaryProps {
  summary: FleetSummaryData;
}

export function FleetSummary({ summary }: FleetSummaryProps) {
  return (
    <div style={cardStyle}>
      <div style={labelStyle}>FLEET SUMMARY</div>
      <div style={statsRowStyle}>
        <Tile
          label="Mean score"
          value={`${summary.meanScorePct}`}
          suffix="%"
          accent={scoreColor(summary.meanScorePct)}
          big
        />
        <Tile label="Corpus jobs" value={summary.corpusJobCount.toString()} accent="#F0F2FF" />
        <Tile label="Graded pages" value={summary.totalGradedPages.toString()} accent="#F0F2FF" />
        <Tile
          label="Last promoted"
          value={summary.lastPromotedAt ? formatRelative(summary.lastPromotedAt) : '—'}
          accent="#B8BDD6"
        />
      </div>
    </div>
  );
}

function Tile({
  label,
  value,
  suffix,
  accent,
  big,
}: {
  label: string;
  value: string;
  suffix?: string;
  accent: string;
  big?: boolean;
}) {
  return (
    <div style={{ flex: 1, minWidth: 140 }}>
      <div style={labelStyle}>{label}</div>
      <div
        style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: big ? 36 : 22,
          fontWeight: 800,
          color: accent,
          lineHeight: 1,
          marginTop: 6,
        }}
      >
        {value}
        {suffix !== undefined && (
          <span style={{ fontSize: big ? 18 : 14, color: '#525870', marginLeft: 4 }}>{suffix}</span>
        )}
      </div>
    </div>
  );
}

function scoreColor(pct: number): string {
  if (pct >= 90) return '#00E87A';
  if (pct >= 70) return '#C49BFF';
  if (pct >= 50) return '#FFD56B';
  return '#FF6B7A';
}

function formatRelative(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return '—';
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
}

const cardStyle: React.CSSProperties = {
  padding: 18,
  background: '#0D0F1C',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 10,
};

const labelStyle: React.CSSProperties = {
  color: '#525870',
  fontSize: 10,
  fontFamily: "'JetBrains Mono', monospace",
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
};

const statsRowStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 24,
  marginTop: 10,
};
